import { render, staticRenderFns } from "./wc-menu.vue?vue&type=template&id=42e10e98&scoped=true&"
import script from "./wc-menu.vue?vue&type=script&lang=js&"
export * from "./wc-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e10e98",
  null
  
)

export default component.exports